import AsanaIcon from './asana.svg'
import ClariCopilotIcon from './clari-copilot.svg'
import ClickupIcon from './clickup.svg'
import GitlabIcon from './gitlab.svg'
import GongIcon from './gong.svg'
import GrainIcon from './grain.svg'
import HubspotIcon from './hubspot.svg'
import IntercomIcon from './intercom.svg'
import JiraIcon from './jira.svg'
import LinearIcon from './linear.svg'
import MicrosoftDynamicsIcon from './microsoft-dynamics.svg'
import MondayIcon from './monday.svg'
import PipedriveIcon from './pipedrive.svg'
import ProductboardIcon from './productboard.svg'
import RoadmunkIcon from './roadmunk.svg'
import SalesforceIcon from './salesforce.svg'
import ShortcutIcon from './shortcut.svg'
import SlackIcon from './slack.svg'
import TrelloIcon from './trello.svg'
import WrikeIcon from './wrike.svg'
import ZendeskIcon from './zendesk.svg'
import ZohoSprintsIcon from './zoho-sprints.svg'
import ZoomIcon from './zoom.svg'

export {
  AsanaIcon,
  ClickupIcon,
  GongIcon,
  GitlabIcon,
  GrainIcon,
  IntercomIcon,
  JiraIcon,
  LinearIcon,
  MondayIcon,
  ProductboardIcon,
  RoadmunkIcon,
  ShortcutIcon,
  SlackIcon,
  TrelloIcon,
  WrikeIcon,
  ZendeskIcon,
  ZohoSprintsIcon,
  ClariCopilotIcon,
  ZoomIcon,
  HubspotIcon,
  SalesforceIcon,
  MicrosoftDynamicsIcon,
  PipedriveIcon,
}
